/* Nazakat Premium Product Page JS */
(function(){
  var root=document.querySelector('.nzp'); if(!root) return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg=JSON.parse(document.getElementById('nzp-data').textContent);
  var fmt=function(n){return '\u20B9'+Math.round(n).toLocaleString('en-IN');};

  /* ---------- gallery ---------- */
  var mainimg=document.getElementById('nzp-mainimg');
  var thumbs=document.getElementById('nzp-thumbs');
  if(thumbs){
    thumbs.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        mainimg.src=b.dataset.full;
        thumbs.querySelectorAll('button').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on');
        if(!reduce && window.gsap) gsap.fromTo(mainimg,{opacity:.3,scale:.97},{opacity:1,scale:1,duration:.35,ease:'power2.out'});
      });
    });
  }

  /* ---------- variants ---------- */
  var sel=document.getElementById('nzp-variant');
  var qtyIn=document.getElementById('nzp-qty');
  var priceEl=document.getElementById('nzp-price');
  var cmpEl=document.getElementById('nzp-cmp');
  var stockEl=document.getElementById('nzp-stock');
  var atcBtn=document.getElementById('nzp-atc');
  var mbarPrice=document.getElementById('nzp-mbar-price');
  function currentVariant(){
    var id=sel?sel.value:cfg.variants[0].id;
    for(var i=0;i<cfg.variants.length;i++) if(String(cfg.variants[i].id)===String(id)) return cfg.variants[i];
    return cfg.variants[0];
  }
  function renderVariant(){
    var v=currentVariant();
    priceEl.textContent=fmt(v.price/100);
    if(mbarPrice) mbarPrice.textContent=fmt(v.price/100);
    if(cmpEl){ if(v.compare_at>v.price){cmpEl.textContent=fmt(v.compare_at/100);cmpEl.style.display='';}else{cmpEl.style.display='none';} }
    if(v.image && mainimg) mainimg.src=v.image;
    if(stockEl){
      if(!v.available){stockEl.innerHTML='Sold out';stockEl.style.display='';}
      else if(v.managed && v.qty>0 && v.qty<=cfg.scarcity_max){
        stockEl.innerHTML='<span class="pulse"></span>Only '+v.qty+(v.qty===1?' unit':' units')+' left'+(cfg.preowned?" \u2014 pre-owned units don't restock":' in stock');
        stockEl.style.display='';
      } else {stockEl.style.display='none';}
    }
    if(atcBtn){ atcBtn.disabled=!v.available; atcBtn.textContent=v.available?'Add to cart':'Sold out'; }
    var bn=document.getElementById('nzp-buynow'); if(bn) bn.disabled=!v.available;
    var matc=document.getElementById('nzp-mbar-atc'); if(matc){matc.disabled=!v.available;matc.textContent=v.available?'Add to cart':'Sold out';}
  }
  if(sel) sel.addEventListener('change',renderVariant);
  renderVariant();
  document.querySelectorAll('.nzp .qbox button').forEach(function(b){
    b.addEventListener('click',function(){
      var v=parseInt(qtyIn.value||'1',10)+(b.dataset.d==='+'?1:-1);
      qtyIn.value=Math.max(1,v);
    });
  });

  /* ---------- cart ---------- */
  function addToCart(items,then){
    var url=(window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:'/cart/add')+'.js';
    return fetch(url,{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:items})
    }).then(function(r){if(!r.ok)throw 0;return r.json();}).then(function(){window.location.href=then||'/cart';})
      .catch(function(){alert('Could not add to cart. Please try again.');});
  }
  function busy(btn,fn){ if(btn.disabled)return; var t=btn.textContent; btn.disabled=true; btn.textContent='Adding\u2026';
    fn().finally(function(){btn.disabled=false;btn.textContent=t;}); }
  function mainItem(){ return {id:parseInt(currentVariant().id,10),quantity:Math.max(1,parseInt(qtyIn&&qtyIn.value||'1',10))}; }
  if(atcBtn) atcBtn.addEventListener('click',function(){busy(atcBtn,function(){return addToCart([mainItem()],'/cart');});});
  var buynow=document.getElementById('nzp-buynow');
  if(buynow) buynow.addEventListener('click',function(){busy(buynow,function(){return addToCart([mainItem()],'/checkout');});});
  var matc=document.getElementById('nzp-mbar-atc');
  if(matc) matc.addEventListener('click',function(){busy(matc,function(){return addToCart([mainItem()],'/cart');});});

  /* ---------- bundle ---------- */
  function bcalc(){
    var v=currentVariant(), t=v.price/100, c=1, s=0;
    document.querySelectorAll('.nzp .bopt').forEach(function(b){ if(b.checked){t+=+b.dataset.price;c++;s+=+b.dataset.save;} });
    document.querySelectorAll('.nzp [data-btotal]').forEach(function(e){e.textContent=fmt(t);});
    document.querySelectorAll('.nzp [data-bcount]').forEach(function(e){e.textContent=c;});
    document.querySelectorAll('.nzp [data-bsave]').forEach(function(e){
      e.textContent=s>0?'You save '+fmt(s)+' on accessories':'Tick accessories to unlock '+cfg.bundle_pct+'% off';
    });
  }
  document.querySelectorAll('.nzp .bopt').forEach(function(b){b.addEventListener('change',bcalc);});
  if(document.querySelector('.nzp .bopt')) bcalc();
  if(sel) sel.addEventListener('change',bcalc);
  document.querySelectorAll('.nzp [data-bundle-atc]').forEach(function(btn){
    btn.addEventListener('click',function(){
      busy(btn,function(){
        var items=[mainItem()];
        document.querySelectorAll('.nzp .bopt:checked').forEach(function(b){items.push({id:parseInt(b.dataset.vid,10),quantity:1});});
        return addToCart(items,'/cart');
      });
    });
  });

  /* ---------- accordions from real description ---------- */
  var srcEl=document.getElementById('nzp-desc-src');
  var accWrap=document.getElementById('nzp-accs');
  var leadEl=document.getElementById('nzp-lead');
  if(srcEl&&accWrap){
    var tmp=document.createElement('div'); tmp.innerHTML=srcEl.innerHTML;
    var groups=[],cur=null,leadDone=false;
    Array.prototype.slice.call(tmp.childNodes).forEach(function(n){
      if(n.nodeType!==1&&!(n.nodeType===3&&n.textContent.trim()))return;
      var tag=n.nodeType===1?n.tagName:'' ;
      var isHead=/^H[1-4]$/.test(tag)||(tag==='P'&&n.children.length===1&&/^(STRONG|B)$/.test(n.children[0].tagName)&&n.textContent.trim().length<70&&n.children[0].textContent.trim()===n.textContent.trim());
      if(isHead){cur={title:n.textContent.replace(/[:\u2013-]\s*$/,'').trim(),nodes:[]};groups.push(cur);}
      else if(cur){cur.nodes.push(n.cloneNode(true));}
      else if(!leadDone&&leadEl&&(tag==='P'||n.nodeType===3)&&n.textContent.trim().length>40){leadEl.textContent=n.textContent.trim();leadDone=true;}
      else{ if(!groups.length){cur={title:cfg.fallback_acc_title||'Product details',nodes:[]};groups.push(cur);} cur.nodes.push(n.cloneNode(true)); }
    });
    if(!groups.length){groups=[{title:cfg.fallback_acc_title||'Product details',nodes:Array.prototype.slice.call(tmp.cloneNode(true).childNodes)}];}
    groups.forEach(function(g,i){
      if(!g.nodes.length)return;
      var acc=document.createElement('div');acc.className='acc'+(i===0?' open':'');
      var btn=document.createElement('button');btn.className='acc-h';btn.type='button';
      btn.innerHTML=g.title+'<svg viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg>';
      var body=document.createElement('div');body.className='acc-b';
      var inner=document.createElement('div');inner.className='acc-c';
      g.nodes.forEach(function(n){inner.appendChild(n);});
      body.appendChild(inner);acc.appendChild(btn);acc.appendChild(body);accWrap.appendChild(acc);
    });
    accWrap.querySelectorAll('.acc-h').forEach(function(h){
      h.addEventListener('click',function(){
        var a=h.parentElement,b=a.querySelector('.acc-b'),open=a.classList.contains('open');
        accWrap.querySelectorAll('.acc').forEach(function(x){x.classList.remove('open');x.querySelector('.acc-b').style.maxHeight=null;});
        if(!open){a.classList.add('open');b.style.maxHeight=b.scrollHeight+'px';}
      });
    });
    var first=accWrap.querySelector('.acc.open .acc-b'); if(first)first.style.maxHeight=first.scrollHeight+'px';
  }

  /* ---------- reveals / parallax / tilt ---------- */
  if(reduce){
    document.querySelectorAll('.nzp .reveal').forEach(function(el){el.style.opacity=1;el.style.transform='none';});
  }else if(window.gsap&&window.ScrollTrigger){
    gsap.registerPlugin(ScrollTrigger);
    document.querySelectorAll('.nzp .reveal').forEach(function(el){
      gsap.to(el,{opacity:1,y:0,duration:.7,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 86%'}});
    });
    var band=document.querySelector('.nzp .band-in');
    if(band) gsap.to(band,{yPercent:-6,ease:'none',scrollTrigger:{trigger:'.nzp .band',start:'top bottom',end:'bottom top',scrub:true}});
  }else{
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){e.target.style.transition='opacity .7s ease, transform .7s ease';e.target.style.opacity=1;e.target.style.transform='none';io.unobserve(e.target);}
    });},{threshold:.12});
    document.querySelectorAll('.nzp .reveal').forEach(function(el){io.observe(el);});
  }
  /* safety: nothing stays hidden */
  setTimeout(function(){document.querySelectorAll('.nzp .reveal').forEach(function(el){if(getComputedStyle(el).opacity==='0'){el.style.transition='opacity .6s ease';el.style.opacity=1;el.style.transform='none';}});},2500);

  var tilt=document.getElementById('nzp-tilt'),stage=document.getElementById('nzp-stage');
  var coarse=matchMedia('(pointer:coarse)').matches;
  if(!reduce&&tilt&&stage&&window.gsap){
    if(!coarse){
      var rx=gsap.quickTo(tilt,'rotationX',{duration:.5,ease:'power2.out'});
      var ry=gsap.quickTo(tilt,'rotationY',{duration:.5,ease:'power2.out'});
      stage.addEventListener('pointermove',function(e){
        var r=stage.getBoundingClientRect();
        ry(((e.clientX-r.left)/r.width-.5)*12);
        rx(-((e.clientY-r.top)/r.height-.5)*10);
      });
      stage.addEventListener('pointerleave',function(){rx(0);ry(0);});
    }else{
      var gx=gsap.quickTo(tilt,'rotationY',{duration:.6,ease:'power2.out'});
      var gy=gsap.quickTo(tilt,'rotationX',{duration:.6,ease:'power2.out'});
      window.addEventListener('deviceorientation',function(e){
        if(e.gamma==null)return;
        gx(Math.max(-10,Math.min(10,e.gamma/4)));
        gy(Math.max(-8,Math.min(8,-(e.beta-45)/6)));
      });
    }
  }
})();
